import { SetupDrawer } from '@Components/shared/dialogs/SetupDrawer';
import { SetupCampaignContent } from './SetupCampaignContent';
import { useCampaignDrawer } from '@Modal/hooks/campaigns/useCampaignDrawer';

export const SetupCampaignDrawer: React.FC = () => {
  const { showCampaignDrawer, handleCreateCancel } = useCampaignDrawer();
  return (
    <SetupDrawer name="SetupCampaign" open={showCampaignDrawer} onClose={handleCreateCancel}>
      <SetupCampaignContent />
    </SetupDrawer>
  );
};
